/**
 * useJoinPageChrome — page-level housekeeping every join screen needs.
 *
 * TWO THINGS, BOTH FROM ONE REPORT (Luis, iPhone Safari, 2026-09-03):
 * "the page is kind of off-center, why is it even scrollable, and the number
 * screen is scrolled to the top so it covers the heading."
 *
 * 1. Scroll to the top on mount. React Router does not restore or reset scroll
 *    position, so the offset from the previous screen carried over: he scrolled
 *    the landing, tapped through, and arrived on the number screen already
 *    scrolled down with "What's your number?" pushed off the top. Every screen
 *    here is a fresh mount, so resetting on mount is enough.
 *
 * 2. Paint the page background on <body>. The screens size themselves to the
 *    SMALL viewport (the height with the browser toolbars showing). If the
 *    viewport ever grows past that, on rotation or when Safari collapses its
 *    toolbar, the strip below the screen would otherwise show the browser's own
 *    unstyled background. Scoped to the join flow and restored on unmount, so
 *    the receipt pages keep whatever they set.
 *
 * The scrolling itself is fixed at the source: each screen's root is sized in
 * `svh` to match its inner column. It used to be `100vh`, which on iOS Safari
 * means the LARGE viewport (toolbars hidden), so the document was about 80 to
 * 100px taller than the visible area and the page scrolled for no reason.
 */
import { useEffect } from 'react';
import { brand } from '../../style/splytBrand';

export default function useJoinPageChrome() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const { body } = document;
    const previous = body.style.backgroundColor;
    body.style.backgroundColor = brand.marsh;
    return () => {
      body.style.backgroundColor = previous;
    };
  }, []);
}
